<template>
  <div class="ec">
    lala
    <Datatable
      :value="hoseData"
      responsive-layout="scroll"
    >
      <Column
        field="device_id"
        header="ID"
        :sortable="true"
      />
      <Column
        field="reading_time"
        header="Leestijd"
        :sortable="true"
      />
      <Column
        field="battery_voltage_sc"
        header="Accu"
      />
      <Column
        field="frame_counter"
        header="Frame"
      />
      <Column
        field="temperature_00"
        header="t0"
      />
    </Datatable>
  </div>
</template>

<script>
  import SanitasService from '@/service/SanitasService';

  export default {
    data() {
      return {
        hoseData: null,
      };
    },
    created() {
      this.sanitasService = new SanitasService();
    },
    mounted() {
        this.getData()
    },
    methods: {
      getData() {
        this.sanitasService
          .getStatusHoses()
          .then((data) => (this.hoseData = data));
      },
    },
  };
</script>
